module.exports = __webpack_public_path__ + "img/marika_hellmund_8.be749191.jpg";